import { render, staticRenderFns } from "./FreqCluster.vue?vue&type=template&id=2e42000c&scoped=true&"
import script from "./FreqCluster.vue?vue&type=script&lang=js&"
export * from "./FreqCluster.vue?vue&type=script&lang=js&"
import style0 from "./FreqCluster.vue?vue&type=style&index=0&id=2e42000c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e42000c",
  null
  
)

export default component.exports